import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { OrganismeDemandeLogement } from '../models/options/organismesDemandeLogement/organismeDemandeLogement';

const resource = 'OrganismesDemandeLogement'

export default class OrganismesDemandeLogementRessources {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string, actifOnly?: boolean) : Promise<PaginatedList<OrganismeDemandeLogement>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString());
    if (actifOnly) params.append('ActifOnly', actifOnly.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
